
export function transformCodes(codeName:string):string{
    if(codeName.toLowerCase() ==='gallagher'){
      return 'G Code';
    }
    return codeName;
  }